<div class="outer-container diagnostics">
  <div class="title main">
    <b>{{className}} </b>
  </div>
  <div class="title">
    Diagnostic - {{ lessonName }}
  </div>

  <div *ngIf="diagnosticLoading" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>

  <div *ngIf="!diagnosticLoading" class="testing-container">
    <div class="sub-title">
      Testing and Assigning Lessons
    </div>

    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between start" class="cards-container">

      <div class="diagnostic-detail-card" *ngIf="diagnosticData.IsELearning">
        <div class="card-header" fxLayoutAlign="space-between">
          <span class="card-title">
            Unassigned
          </span>
          
          <div class="badgeRelativePosition" *ngIf="diagnosticData.DiagExamSkippedCount > 0">
            <mat-icon class="link-icon" (click)="onUnassignedLinkClick()">
              link
            </mat-icon>
            <div class="notificationBadge">
              <app-notification-badge 
                [displayString]="diagnosticData.DiagExamSkippedCount"
                [hoverString]="diagnosticData.DiagExamSkippedCount+ ' student' + (diagnosticData.DiagExamSkippedCount > 1 ? 's' :'') + '  in diagnostic exam skip list.'"
                [size]="'small'"
                [color]="'warn'">
              </app-notification-badge>
            </div>
          </div>

          <button *ngIf="diagnosticData?.StudentsUnassigned && diagnosticData?.StudentsUnassigned?.length" mat-button class="outline-btn btn-blue"
            (click)="$event.stopPropagation(); onAssignAllUnassignedClick()">
            Assign All
          </button>
        </div>

        <div *ngIf="diagnosticData" class="card-body">
          <div class="card-row" *ngFor="let student of diagnosticData?.StudentsUnassigned">
            <div fxLayout="row" fxLayoutAlign="space-between">
              <div fxFlex="30" class="student-name">
                {{ student.StudentName }}
              </div>
              <div class="assign-text row-link"
                (click)="onAssignUnassignedClick(student.StudentID, student.StudentName)">
                Assign
              </div>
              <div class="skip-text row-link" (click)="onSkipUnassignedClick(student.StudentID, student.StudentName)">
                Skip
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="diagnostic-detail-card" *ngIf="diagnosticData.IsELearning">
        <div class="card-header" fxLayoutAlign="space-between">
          <span class="card-title">
            Grade Test
          </span>
          <button *ngIf="diagnosticData.StudentsNotStartedExam.length" mat-button class="outline-btn-med btn-blue"
            (click)="$event.stopPropagation(); onNotStarted()">
            Not Started
          </button>
          <button *ngIf="diagnosticData.StudentsExamInProgress.length" mat-button class="outline-btn-med btn-blue"
            (click)="$event.stopPropagation(); onInProgress()">
            In Progress
          </button>
        </div>

        <div *ngIf="diagnosticData" class="card-body">
          <div class="card-row" *ngFor="let student of diagnosticData.StudentsNeedDiagGraded">
            <div fxLayout="row" fxLayoutAlign="space-between">
              <div fxFlex="30" class="student-name">
                {{ student.StudentName }}
              </div> 
              <div class="icon-wrapper">
                <a target="_blank" 
                  [routerLink]="['/ELearning/ViewWork']"
                  [queryParams]="{
                    AttemptID: student.AttemptID,
                    AssignmentID: diagnosticData.AssignmentID,
                    AssignmentName: lessonName,
                    StudentName: student.StudentName
                  }">
                  <mat-icon class="material-icons-outlined icon">description</mat-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="diagnostic-detail-card" *ngIf="!diagnosticData.IsELearning">
        <div class="card-header">
          <span class="card-title">
            Manage Bubbles Exam
          </span>
        </div>
        
        <div class="card-body">
          <a href="/BubbleProcessing/ManageBatches?ddeid={{diagnosticData.DimDistrictExamID}}">
            <button mat-button class="outline-btn btn-blue">
            Bubbles Exam Link
          </button></a>
        </div>
        
      </div>

      <div class="diagnostic-detail-card">
        <div class="card-header" fxLayoutAlign="space-between">
          <span class="card-title">
            Assign Lessons
          </span>

          <div class="badgeRelativePosition" *ngIf="diagnosticData.DiagLessonsSkippedCount > 0">
            <mat-icon class="link-icon" (click)="onAssignLessonsLinkClick()">
              link
            </mat-icon>
            <div class="notificationBadge">
              <app-notification-badge 
                [displayString]="diagnosticData.DiagLessonsSkippedCount"
                [hoverString]="diagnosticData.DiagLessonsSkippedCount + ' student' + (diagnosticData.DiagLessonsSkippedCount > 1 ? 's' :'') + ' in assign lessons skip list.'"
                [size]="'small'"
                [color]="'warn'">
              </app-notification-badge>
            </div>
          </div>

          <button *ngIf="diagnosticData.StudentsawaitingILP.length" mat-button class="outline-btn btn-blue"
            (click)="$event.stopPropagation(); onAssignLessons()">
            Assign All
          </button>
        </div>

        <div *ngIf="diagnosticData" class="card-body">
          <div class="card-row" *ngFor="let student of diagnosticData.StudentsawaitingILP">
            <div fxLayout="row" fxLayoutAlign="space-between">
              <div fxFlex="30" class="student-name">
                {{ student.StudentName }}
              </div>
              <div class="student-grade">
                {{student.Grade}}
               </div>
              <div class="assign-text row-link" (click)="onAssignStudentLessons(student)">
                Assign
              </div>
              <div class="skip-text row-link" (click)="onSkipAssignedClick(student.StudentID, student.StudentName)">
                Skip
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!diagnosticLoading" class="track-container">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="sub-title">
        Track Lesson Progress
      </div>

      <a mat-stroked-button color="primary" [routerLink]="['/ELearning/Class', classID]">Gradebook</a>

      <div class="exp-col-cont">
        <span class="expand-all exp-col" (click)="onExpandAll()">
          Expand All
        </span>
        <span class="collapse-all exp-col" (click)="onCollapseAll()">
          Collapse All
        </span>
      </div>
    </div>
    <mat-accordion [multi]="true" #accordion="matAccordion">
      <div *ngFor="let student of studentsWithLessons">
        <app-student-panel 
        [studentData]="student" 
        [isExpanded]="isExpanded" 
        [classID]="classID"
        [diagExamID]="diagnosticExamID"
        (unassigned)="unassignedResults($event)"
        >
        </app-student-panel>
      </div>

      <div *ngFor="let student of diagnosticData.StudentsYieldedNoILP">
        <app-student-panel
        [studentData]="student"
        [isExpanded]="isExpanded"
        [classID]="classID"
        [diagExamID]="diagnosticExamID"
        (released)="releasedResults($event)"
        (unassigned)="unassignedResults($event)"
        (removeFromSkipList)="removeFromLessonsSkip($event)"
        ></app-student-panel>
      </div>
    </mat-accordion>
  </div>

 

</div>
